import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';

import { STATES } from '@app/shared/constants/states';

@Component({
  selector: 'app-state-filter-dialog',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatSelectModule,
    MatFormFieldModule,
    MatChipsModule,
    MatIconModule,
  ],
  templateUrl: './state-filter-dialog.component.html',
  styleUrl: './state-filter-dialog.component.scss',
})
export class StateFilterDialogComponent {
  form: FormGroup;

  states = STATES;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      label: string;
      values: string[];
    },
    private dialogRef: MatDialogRef<StateFilterDialogComponent>,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      states: [this.data.values ?? []],
    });
  }

  removeState(stateCode: string): void {
    const currentStates = this.form.get('states')?.value ?? [];

    this.form.get('states')?.setValue(
      currentStates.filter((state: string) => state !== stateCode)
    );
  }

  save(): void {
    this.dialogRef.close(this.form.get('states')?.value ?? []);
  }

  clear(): void {
    this.dialogRef.close([]);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}